import { takeLatest, put, call, select, take } from "redux-saga/effects";
import * as API from "us.collection.documents/services";
import * as Actions from "us.collection.documents/actions";
import { CaseDocuments } from "us.collection.documents/constants/Actions";
import { getLookUpTypeByCaseType } from "us.collection.documents/functions";
import { $Message, $MessageBox } from "us.common/components";

const { caseDocuments } = Actions;

const CaseDocumentsSagas = {
  caseDocuments: {
    get: function* (action: any) {
      const params = action?.payload.data ?? {};
      try {
        const { data, status } = yield call(
          API.caseDocuments.documents.get,
          params
        );
        if (
          !Array.isArray(data) &&
          (data?.code == 400 || data?.code == 404 || data?.errors?.length != 0)
        ) {
          yield put(caseDocuments.documents.fail(data));
          $Message.error(data?.errors[0]);
        } else if (status == 204) {
          yield put(caseDocuments.documents.fail({}));
        } else {
          yield put(caseDocuments.documents.success(data));
        }
      } catch (error: any) {
        yield put(caseDocuments.documents.fail(error));
      }
    },
    upload: function* (action: any): Generator<any, void, any> {
      const params = action?.payload?.data ?? {};
      const fileList = action?.payload?.fileList ?? [];
      try {
        const data = yield call(
          API.caseDocuments.documents.upload,
          fileList,
          params
        );
        const jData = JSON.parse(data);
        if (
          !Array.isArray(jData) &&
          (jData?.code == 400 ||
            jData?.code == 404 ||
            jData?.errors ||
            jData?.isError)
        ) {
          if (caseDocuments.documents.uploadFail) {
            yield put(caseDocuments.documents.uploadFail(jData));
            $Message.error(
              jData?.errors != undefined
                ? jData?.errors[0]
                : jData?.errorMessage
            );
          }
        } else {
          if (caseDocuments.documents.uploadSuccess) {
            yield put(caseDocuments.documents.uploadSuccess(jData));
            $Message.success("Successfully Uploaded.");
            if (caseDocuments.document.manageUploadDrawer) {
              yield put(
                caseDocuments.document.manageUploadDrawer({
                  title: "",
                  visible: false,
                })
              );
            }
            if (caseDocuments.documents.get) {
              yield put(
                caseDocuments.documents.get({
                  entityType: params?.entityType,
                  entityId: params?.entityId,
                })
              );
            }
          }
        }
      } catch (error: any) {
        if (caseDocuments.documents.uploadFail) {
          yield put(caseDocuments.documents.uploadFail(error));
          $Message.error(error[0]);
        }
      }
    },
  },
  caseDocument: {
    get: function* (action: any): Generator<any, void, any> {
      const params = action?.payload.data ?? {};
      try {
        const data = yield call(API.caseDocuments.document.get, params);
        if (data?.code == 400 || data?.code == 404 || data?.errors) {
          yield put(caseDocuments.document.fail(data));
          $Message.error(data?.errors[0]);
        } else {
          yield put(caseDocuments.document.success(data));
        }
      } catch (error: any) {
        yield put(caseDocuments.document.fail(error));
      }
    },
    delete: function* (action: any): Generator<any, void, any> {
      const params = action?.payload.data ?? {};
      try {
        const data = yield call(API.caseDocuments.document.delete, params);
        if (data?.code == 400 || data?.code == 404 || data?.errors) {
          if (caseDocuments.document.deleteFail) {
            yield put(caseDocuments.document.deleteFail(data));
            $Message.error(data?.message);
          }
        } else {
          if (caseDocuments.document.deleteSuccess) {
            yield put(caseDocuments.document.deleteSuccess(data));
            $Message.success(data?.message);
          }
        }
      } catch (error: any) {
        if (caseDocuments.document.deleteFail) {
          yield put(caseDocuments.document.deleteFail(error));
          $Message.error(error);
        }
      }
    },
  },
  categories: {
    get: function* (action: any) {
      const params = action?.payload.data ?? {};
      try {
        const { status, data } = yield call(
          API.caseDocuments.categories.get,
          params
        );
        if (status == 200) {
          yield put(caseDocuments.categories.success(data));
        } else {
          yield put(caseDocuments.categories.fail(data));
        }
      } catch (error: any) {
        yield put(caseDocuments.categories.fail(error));
      }
    },
  },
  rules: {
    get: function* (action: any): Generator<any, void, any> {
      const params = action?.payload.data ?? {};
      try {
        const data = yield call(API.caseDocuments.rules.get, params);
        if (data?.code == 400 || data?.code == 404 || data?.errors) {
          yield put(caseDocuments.rules.fail(data));
          $Message.error(data?.errors[0]);
        } else {
          yield put(caseDocuments.rules.success(data));
        }
      } catch (error: any) {
        yield put(caseDocuments.rules.fail(error));
      }
    },
  },
  category: {
    update: function* (action: any) {
      const params = action?.payload.data ?? {};
      try {
        const { data, status } = yield call(
          API.caseDocuments.category.update,
          params
        );
        if (status == 200) {
          yield put(caseDocuments.category.success(data));
          const { data: categories, status: CategoryStatus } = yield call(
            API.caseDocuments.categories.get,
            ""
          );
          if (CategoryStatus == 200) {
            yield put(caseDocuments.categories.success(categories));
          } else {
            yield put(caseDocuments.categories.fail(categories));
          }
          $MessageBox(
            "success",
            "US.COLLECTION.DOCUMENTS:COMMON.SUCCESSFULLY_UPDATED",
            "",
            ""
          );
        } else if(status == 401) {
          yield put(caseDocuments.category.fail(data));
          $MessageBox(
            "error",
            "US.COLLECTION.DOCUMENTS:COMMON.NO_UPDATE_PRIVILEGE",
            "",
            ""
          );
        } else {
          yield put(caseDocuments.category.fail(data));
          $MessageBox(
            "error",
            "US.COLLECTION.DOCUMENTS:COMMON.UPDATE_FAILED",
            "",
            ""
          );
        }
      } catch (error: any) {
        yield put(caseDocuments.category.fail(error));
        $MessageBox(
          "error",
          "US.COLLECTION.DOCUMENTS:COMMON.UPDATE_FAILED",
          "",
          ""
        );
      }
    },
    delete: function* (action: any) {
      const params = action?.payload.data ?? {};
      try {
        const { data, status } = yield call(
          API.caseDocuments.category.delete,
          params
        );
        if (status == 200) {
          if (caseDocuments.category.deleteSuccess) {
            yield put(caseDocuments.category.deleteSuccess(data));
            const { data: categories, status: CategoryStatus } = yield call(
              API.caseDocuments.categories.get,
              ""
            );
            if (CategoryStatus == 200) {
              yield put(caseDocuments.categories.success(categories));
            } else {
              yield put(caseDocuments.categories.fail(categories));
            }
          }
          $MessageBox(
            "success",
            "US.COLLECTION.DOCUMENTS:COMMON.DELETED_SUCCESSFULLY",
            "",
            ""
          );
        } else if(status == 401) {
          if (caseDocuments.category.deleteFail) {
            yield put(caseDocuments.category.deleteFail(data));
          }
          $MessageBox(
            "error",
            "US.COLLECTION.DOCUMENTS:COMMON.NO_DELETION_PRIVILEGE",
            "",
            ""
          );
        } else {
          if (caseDocuments.category.deleteFail) {
            yield put(caseDocuments.category.deleteFail(data));
          }
          $MessageBox(
            "error",
            "US.COLLECTION.DOCUMENTS:COMMON.DELETION_FAILED",
            "",
            ""
          );
        }
      } catch (error) {
        if (caseDocuments.category.deleteFail) {
          yield put(caseDocuments.category.deleteFail(error));
        }
        $MessageBox(
          "error",
          "US.COLLECTION.DOCUMENTS:COMMON.DELETION_FAILED",
          "",
          ""
        );
      }
    },
  },
};

export default [
  takeLatest(
    CaseDocuments.GET_CASE_DOCUMENTS,
    CaseDocumentsSagas.caseDocuments.get
  ),
  takeLatest(
    CaseDocuments.GET_CASE_DOCUMENT_CONTENT,
    CaseDocumentsSagas.caseDocument.get
  ),
  takeLatest(
    CaseDocuments.DELETE_CASE_DOCUMENT,
    CaseDocumentsSagas.caseDocument.delete
  ),
  takeLatest(
    CaseDocuments.UPLOAD_DOCUMENTS,
    CaseDocumentsSagas.caseDocuments.upload
  ),
  takeLatest(
    CaseDocuments.GET_DOCUMENT_CATEGORIES,
    CaseDocumentsSagas.categories.get
  ),
  takeLatest(CaseDocuments.GET_UPLOAD_FILE_RULES, CaseDocumentsSagas.rules.get),
  takeLatest(
    CaseDocuments.UPDATE_DOCUMENT_CATEGORY,
    CaseDocumentsSagas.category.update
  ),
  takeLatest(
    CaseDocuments.DELETE_DOCUMENT_CATEGORY,
    CaseDocumentsSagas.category.delete
  ),
];
